import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import { engagementIncentivesService } from "../../../services/api/engagement-incentives.endpoints";
import store from "../../../store";

async function getExequteQuery(
  oauthTokenHeader: string,
  setExequteQueryContent: any,
  website_shared_uid: string[],
  start_date: any,
  end_date: any,
  QUERY_ID: any
) {
  try {
    const response = await engagementIncentivesService.getExequteQuery(
      oauthTokenHeader,
      website_shared_uid,
      start_date,
      end_date,
      QUERY_ID
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      setExequteQueryContent(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function postExequteQuery(
  oauthTokenHeader: string,
  data: any,
  setExequteQueryMessage: any
) {
  try {
    const response = await engagementIncentivesService.postExequteQuery(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 201) {
      throw new Error();
    } else {
      setExequteQueryMessage(response?.data?.reason);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function putExequteQuery(
  oauthTokenHeader: string,
  data: any,
  itb_shared_uid: any,
  setExequteQueryMessage: any
) {
  try {
    const response = await engagementIncentivesService.putExequteQuery(
      oauthTokenHeader,
      data,
      itb_shared_uid
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      setExequteQueryMessage(response?.data?.reason);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getExequteQueryForDuplicateBudget(
  oauthTokenHeader: string,

  website_shared_uid: string[],
  start_date: any,
  end_date: any,
  QUERY_ID: any
) {
  try {
    const response = await engagementIncentivesService.getExequteQuery(
      oauthTokenHeader,
      website_shared_uid,
      start_date,
      end_date,
      QUERY_ID
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function postDuplicateBudget(
  oauthTokenHeader: string,
  data: any,
  setExequteQueryMessage?: (message: string) => void
) {
  try {
    const response = await engagementIncentivesService.postDuplicateBudget(
      oauthTokenHeader,
      data
    );

    const status = response?.status;
    const responseData = response?.data;

    if (status !== 201 && status !== 207 && status !== 400) {
      throw new Error();
    }

    if (setExequteQueryMessage) {
      setExequteQueryMessage(
        responseData?.reason || "Successfully posted duplicate budget"
      );
    }

    return { status, ...responseData }; // Return full response structure
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Unknown error occurred while posting duplicate budget",
        type: "error",
      })
    );
  }
}

export const engagementIncentivesEndPointLogic = {
  getExequteQuery,
  postExequteQuery,
  putExequteQuery,
  getExequteQueryForDuplicateBudget,
  postDuplicateBudget,
};
